<template>
  <div class="themeEdu">
    <div class="banner">
      <img src="@/assets/index/theme/dp-sy-zt1.png" alt />
    </div>
    <div class="choose-title">
      <span
        v-for="(choose,index) in chooses"
        :key="choose.title"
        :class="chooseNum==index?'choosed':''"
        @click="active(index)"
      >{{choose.title}}</span>
    </div>
    <!-- 百部优秀课件推荐 -->
    <div class="remonmend" v-if="chooseNum==0">
      <div class="small-video">
        <div class="small-template" v-for="smallVideo in smallVideos" :key="smallVideo.name" @click="goVideoLsit(smallVideo.name)">
          <img :src="smallVideo.imgUrl" alt />
          <p v-text="smallVideo.name"></p>
        </div>
      </div>

      <div class="example">
        <div class="example-title">《榜样》栏目</div>
        <div class="example-box">
          <div
            class="example-template"
            v-for="example in examples"
            :key="example.id"
            @click="goDetail(example.path)"
          >
            <img :src="example.imgurl | filterC " alt />
            <p v-text="example.title"></p>
            <p v-text="example.source"></p>
          </div>
        </div>
      </div>

      <div class="xi-list">
        <div class="xi-list-title">《追寻习近平总书记的初心》系列专题片</div>
        <div class="xi-list-box">
          <div
            class="news-template"
            v-for="news in xiLine"
            :key="news.id"
            @click="goDetail(news.path)"
          >
            <div class="news-left">
              <img :src="news.imgurl | filterC" alt v-if="news.imgurl==null?false:true" />
            </div>
            <div class="news-right">
              <p>{{news.title}}</p>
              <p>{{news.source}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="seven-list">
        <div class="seven-list-title">七集政论专题片《不忘初心 继续前进》</div>
        <div class="seven-list-box">
          <div
            class="news-template"
            v-for="news in sevenLine"
            :key="news.id"
            @click="goDetail(news.path)"
          >
            <div class="news-left">
              <img :src="news.imgurl " alt v-if="news.imgurl==null?false:true" />
            </div>
            <div class="news-right">
              <p>{{news.title}}</p>
              <p>{{news.source}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频课件 -->
    <div class="video-class" v-if="chooseNum==1"> 
      <div class="list" v-for="(news,index) in videoClass" :key="index">
        <div class="list-title">{{news.type}}</div>
        <div class="list-box">
          <div
            class="news-template"
            v-for="name in news.msg"
            :key="name.id"
            @click="goDetail(name.newpath)"
          >
            <div class="news-left">
              <img :src="name.imgurl " alt v-if="name.imgurl==null?false:true" />
            </div>
            <div class="news-right">
              <p>{{name.title}}</p>
              <p v-if="news.source">{{name.source}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图文课件 -->
    <div class="img-class" v-if="chooseNum==2">
       <div
        class="news-template"
        v-for="news in textClass"
        :key="news.id"
        @click="gotextDetail(news.id)"
      >
        <div class="news-left">
          <img :src="findImg(news.memo)" v-show="findImg(news.memo)" />
        </div>
        <div class="news-right">
          <p>{{news.headline}}</p>
          <p>
            <!-- <span style="margin-right:.5rem;">浏览:{{news.sees}}</span>
            <span>点赞:{{news.praise}}</span> -->
            <span style="margin-right:.3rem;float:right">{{news.createtime|times}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [
        { title: "百部优秀课件推荐" },
        { title: "视频课件" },
        { title: "图文课件" }
      ],
      chooseNum: 0,
      smallVideos: [
        {
          name: "纪录片",
          imgUrl: require("@/assets/index/theme/dp-sy-zt2.png")
        },
        {
          name: "典型人物事迹片",
          imgUrl: require("@/assets/index/theme/dp-sy-zt3.png")
        },
        {
          name: "微视频",
          imgUrl: require("@/assets/index/theme/dp-sy-zt4.png")
        }
      ],
      examples: [],
      xiLine: [],
      sevenLine: [],
      videoClass: [],
      textClass:[]
    };
  },
  methods: {
    active(index) {
      this.chooseNum = index;
      switch (index) {
        case 1:
          this.axios.get("/api/Main/video").then(e => {
            console.log(e.data);
            if (e.data.code == 0) {
              // this.videoClass = e.data.msg;
              let arrs = [];
              e.data.msg.filter(item => {
                if (!arrs.includes(item.type)) {
                  arrs.push(item.type);
                }
              });
              arrs.filter(item => {
                this.videoClass.push({ type: item });
              });

              this.videoClass.filter((item, index) => {
                this.videoClass[index].msg = [];
                e.data.msg.filter(msg => {
                  if (msg.type == item.type) {
                    this.videoClass[index].msg.push(msg);
                  }
                });
              });
            }
          });
          break;
        case 2:
          this.axios.get("/api/Main/ImageText").then(e => {
            // console.log(e.data);
            if (e.data.code == 0) {
              this.textClass = e.data.msg;
              return

              let arrs = [];
              e.data.msg.filter(item => {
                if (!arrs.includes(item.type)) {
                  arrs.push(item.type);
                }
              });
              arrs.filter(item => {
                this.videoClass.push({ type: item });
              });

              this.videoClass.filter((item, index) => {
                this.videoClass[index].msg = [];
                e.data.msg.filter(msg => {
                  if (msg.type == item.type) {
                    this.videoClass[index].msg.push(msg);
                  }
                });
              });
              // console.log(this.textClass)
            }
          });
          break;
        default:
          break;
      }
    },
    goDetail(sourceLink) {
      this.$router.push({
        path: "iframeVedio",
        query: { title: "视频播放", iframeUrl: sourceLink }
      });
    },
    goVideoLsit(value){
      // console.log(value);
      this.$router.push({path:'/themeedu/viedeolist',query:{title:value,url:'/api/Main/videoList',type:'get'}})
    },
    findImg(value) {
      if (value.indexOf("img") > -1) {
        return value.split('src="')[1].split('"')[0];
      } else {
        return false;
      }
    },
    gotextDetail(newsid){
      this.$router.push({
        path: "/publicDetail",
        query: { title: "新闻动态", id: newsid, dbnum: 1 }
      });
    }
  },
  created: function() {
    this.axios
      .get("/api/Main/Theme")
      .then(e => {
        switch (e.data.code) {
          case 0:
            e.data.msg.filter(item => {
              if (item.type == "《榜样》栏目") {
      
                
                this.examples.push(item);
              } else if (item.type == "《追寻习近平总书记的初心》系列专题片") {
                this.xiLine.push(item);
              } else {
                this.sevenLine.push(item);
              }
            });

            break;
          default:
            alert("错误,请稍后重试");
            break;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  filters: {
    filterB: function(value) {
      return `http://dpadmin.djplus.cn/Pimg/${value}`;
    },
    filterC:function(value){
      if(value!=undefined)
      return value.indexOf('http')>-1?value:`http://qswgadmin.djplus.cn//Tittle/${value}`
    }
  }
};
</script>

<style lang="scss" scoped>
.themeEdu {
  .video-class {
    .list {
      .list-title {
        line-height: 3;
        font-weight: bold;
        width: 94%;
        margin: 0 auto;
      }
      .news-template {
        width: 94%;
        margin: 0 auto;
        display: flex;
        margin-bottom: 0.2rem;
        padding: 0.2rem 0;
        border-bottom: 0.01rem solid #ddd;
        .news-right {
          width: 100%;
          margin-left: 0.2rem;
          p:nth-child(1) {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            margin-bottom: 0.3rem;
            line-height: 1.8;
          }
          p:nth-child(2) {
            // border-top: 0.01rem solid #e6e6e6;
            padding-top: 0.2rem;
            color: #999999;
            font-size: 0.26rem;
          }
        }
        .news-left {
          img {
            width: 2.4rem;
            height: 2rem;
          }
        }
      }
    }
    background: #fff;
    margin-top: 0.3rem;
  }

  .img-class {
    .news-template {
      width: 94%;
      margin: 0 auto;
      display: flex;
      margin-bottom: 0.2rem;
      background: #fff;
      padding: 0.2rem 0;
      border-radius: 0.16rem;
      //   align-items: center;
      .news-right {
        width: 100%;
        margin-left: 0.2rem;
        p:nth-child(1) {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          margin-bottom: 0.3rem;
          line-height: 1.8;
        }
        p:nth-child(2) {
          border-top: 0.01rem solid #e6e6e6;
          padding-top: 0.2rem;
          color: #999999;
          font-size: 0.26rem;
        }
      }
      .news-left {
        img {
          width: 2.4rem;
          height: 2rem;
        }
      }
    }
    margin-top: 0.3rem;
  }

  .seven-list {
    .seven-list-box {
      .news-template {
        width: 94%;
        margin: 0 auto;
        display: flex;
        margin-bottom: 0.2rem;
        padding: 0.2rem 0;
        border-bottom: 0.01rem solid #ddd;
        .news-right {
          width: 100%;
          margin-left: 0.2rem;
          p:nth-child(1) {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            margin-bottom: 0.3rem;
            line-height: 1.8;
          }
          p:nth-child(2) {
            // border-top: 0.01rem solid #e6e6e6;
            padding-top: 0.2rem;
            color: #999999;
            font-size: 0.26rem;
          }
        }
        .news-left {
          img {
            width: 2.4rem;
            height: 2rem;
          }
        }
      }
    }
    .seven-list-title {
      line-height: 3;
      font-weight: bold;
      width: 94%;
      margin: 0 auto;
    }
    background: #fff;
    margin-top: 0.3rem;
  }

  .xi-list {
    .xi-list-box {
      .news-template {
        width: 94%;
        margin: 0 auto;
        display: flex;
        margin-bottom: 0.2rem;
        padding: 0.2rem 0;
        border-bottom: 0.01rem solid #ddd;
        .news-right {
          width: 100%;
          margin-left: 0.2rem;
          p:nth-child(1) {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            margin-bottom: 0.3rem;
            line-height: 1.8;
          }
          p:nth-child(2) {
            // border-top: 0.01rem solid #e6e6e6;
            padding-top: 0.2rem;
            color: #999999;
            font-size: 0.26rem;
          }
        }
        .news-left {
          img {
            width: 2.4rem;
            height: 2rem;
          }
        }
      }
    }
    .xi-list-title {
      line-height: 3;
      font-weight: bold;
      width: 94%;
      margin: 0 auto;
    }
    background: #fff;
    margin-top: 0.3rem;
  }

  .example {
    .example-box {
      .example-template {
        p{
          &:nth-child(3){
            font-size: .26rem;
            color: #999999;
          }
        }
        img {
          width: 2.2rem;
        }
        width: 30%;
        margin-right: 3%;
      }
      display: flex;
      align-items: center;
      overflow-x: scroll;
      white-space: nowrap;
      width: 94%;
      margin: 0 auto;
      padding-bottom: 0.3rem;
    }
    .example-title {
      line-height: 3;
      background: #fff;
      padding-left: 0.2rem;
      font-weight: bold;
    }
    margin-top: 0.2rem;
    background: #fff;
  }
  .small-video {
    .small-template {
      img {
        width: 1.1rem;
        height: 1.1rem;
        border-radius: 50%;
      }
      text-align: center;
      width: 33%;
      margin: 0.3rem 0;
    }
    display: flex;
    align-items: center;
    overflow-x: scroll;
    white-space: nowrap;
    background: #fff;
    margin-top: 0.1rem;
  }
  .choose-title {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    width: 100%;
    white-space: nowrap;
    background: #fff;

    line-height: 3;
    span {
      margin: 0 0.3rem;
    }
    .choosed {
      font-weight: 600;
      color: #ffa000;
      position: relative;
      &::before {
        position: absolute;
        width: 50%;
        left: 25%;
        height: 0.08rem;
        border-radius: 0.1rem;
        background-color: #ffa000;
        content: "";
        bottom: 0;
      }
    }
  }
  .banner {
    img {
      width: 100%;
    }
    width: 94%;
    margin: 0 auto;
  }
  font-size: 0.3rem;
  padding-top: 1.1rem;
}
</style>